import { render } from "./login.html?vue&type=template&id=bda051ea"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./login.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script